import { createSlice } from '@reduxjs/toolkit';
import { fetchDashboardStats, fetchProjectTrends, fetchUserStats } from '../thunks/dashboardThunks';

const initialState = {
  stats: null,
  projectTrends: [],
  userStats: null,
  loading: false,
  error: null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Dashboard Stats
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload.data;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch Project Trends
      .addCase(fetchProjectTrends.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectTrends.fulfilled, (state, action) => {
        state.loading = false;
        state.projectTrends = action.payload.data;
      })
      .addCase(fetchProjectTrends.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch User Stats
      .addCase(fetchUserStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserStats.fulfilled, (state, action) => {
        state.loading = false;
        state.userStats = action.payload.data;
      })
      .addCase(fetchUserStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearError } = dashboardSlice.actions;
export default dashboardSlice.reducer;